import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';

const Sliders = ({label}) => {
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    const [products,setProducts] = useState([]);

    const fetchData = async () =>{
        try {
            let url = `${apiBaseUrl}getProductByLabel?label=${label}`;
            const response = await fetch(url);
            const data = await response.json();
            console.log('products result',data)
            setProducts(data.data);
            return data;
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect( () => {
        fetchData();
    },[label])

  const settings = {
    dots: true, // Display dots for navigation
    infinite: true, // Infinite loop
    speed: 500, // Speed of slide transition
    slidesToShow: 4, // Default number of slides to show
    slidesToScroll: 1, // Number of slides to scroll at once
    responsive: [
      {
        breakpoint: 1024, // For tablets
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600, // For mobile devices
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className="slider-container">
      <Slider {...settings}>
        {
            products.map((product) => (
                <div className='p-4'>
                    <div className='card p-3'>
                        <Link to={`/products/${product.product_code}`}>
                            <img src={product.thumbnail} alt={product.name} className='img-fluid productThumbnail'/>
                        </Link>
                        <hr data-content={product.categoryname} class="hr-text" />
                        <h4 className='pl-2 pb-1 m-0' title={product.name}>
                            {product.name.substr(0, 15)}{product.name.length > 19 ? '...' : ''}
                        </h4>
                        <p className='m-0 pl-2 pb-1'>₹<b>{product.price.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}/-</b></p>
                        <div className='position-relative row mt-2'>
                            <div className='col-2'>
                                <i class="fa fa-heart mr-1 heartIcon"></i>
                            </div>
                            <div className='col-10'>
                                <Link to={`/products/${product.product_code}`} style={{textDecoration:"none"}}>
                                    <button className="button-53 w-100" role="button">
                                        View Product
                                    </button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            ))
        }
      </Slider>
    </div>
  );
};

export default Sliders;
